<template>
  <div style="width: 80% !important">
    <v-progress-linear
      :indeterminate="true"
      v-if="loading"
      style="position: absolute; top: 0; left: 0; margin: 0"
    ></v-progress-linear>
    <uploader :saveUpload="saveUpload" />
    <file-history :histories="histories" />
    <v-snackbar v-model="snackbar.visible" :bottom="true" :right="true" :color="snackbar.color">
      {{snackbar.text}}
      <v-btn dark flat @click="snackbar.visible = false">Fermer</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import Uploader from "@/components/Uploader";
import FileHistory from "@/components/FileHistory";
import axios from "axios";
import files from "../doc/files";
import {
  parseISO,
  min,
  eachDayOfInterval,
  getDate,
  getMonth,
  addMonths,
  addYears,
  format,
} from "date-fns";

export default {
  name: "file",
  components: {
    Uploader,
    FileHistory,
  },
  data: () => ({
    histories: undefined,
    loading: false,
    snackbar: {
      visible: false,
      color: "",
      text: "",
    },
  }),
  async mounted() {
    const { data: histories } = await axios({
      method: "GET",
      url: `${process.env.VUE_APP_API_URI}/history?originalname=${this.$router.history.current.name}`,
    });
    const { frequency } = files.find(
      (f) => f.name === this.$router.history.current.name
    );
    const minDate = min(histories.map((h) => parseISO(h.createdAt)));
    const maxDate = new Date();
    var interval = eachDayOfInterval({
      start: minDate,
      end:
        frequency === "monthly" ? addMonths(maxDate, 1) : addYears(maxDate, 1),
    })
      .filter((d) => {
        return frequency === "monthly"
          ? getDate(d) === 10
          : getDate(d) === 10 && getMonth(d) === 1;
      })
      .map((d) => ({
        type: "milestone",
        createdAt: format(d, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"),
      }));
    histories.push(...interval);

    this.histories = histories.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );
  },
  watch: {
    $route: async function (to) {
      const { data: histories } = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_API_URI}/history?originalname=${to.name}`,
      });
      const { frequency } = files.find((f) => f.name === to.name);
      const minDate = min(histories.map((h) => parseISO(h.createdAt)));
      const maxDate = new Date();
      var interval = eachDayOfInterval({
        start: minDate,
        end:
          frequency === "monthly"
            ? addMonths(maxDate, 1)
            : addYears(maxDate, 1),
      })
        .filter((d) => {
          return frequency === "monthly"
            ? getDate(d) === 10
            : getDate(d) === 10 && getMonth(d) === 1;
        })
        .map((d) => ({
          type: "milestone",
          createdAt: format(d, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"),
        }));
      histories.push(...interval);
      this.histories = histories;
      this.histories = histories.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
    },
  },
  methods: {
    saveUpload: async function (history) {
      this.loading = true;
      try {
        const { data: histories } = await axios({
          method: "POST",
          url: `${process.env.VUE_APP_API_URI}/save`,
          data: history,
        });
        const milestones = this.histories.filter((h) => h.type === "milestone");
        histories.push(...milestones);
        this.histories = histories.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        this.loading = false;
        this.snackbar = {
          visible: true,
          color: "success",
          text: "Fichier déposé avec succès",
        };
      } catch (error) {
        this.loading = false;
        this.snackbar = {
          visible: true,
          color: "error",
          text: "Erreur de dépôt du fichier",
        };
      }
    },
  },
};
</script>

